module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC3SURBVHgBfZKBEYMgDEUNDFJGgA3sJnaydpO6AYxABwGacOJFCeSOE+N/5pMA1lqjtX7nnDfv/W+ZBNcq2mBuBYDdOfeYQUqpL2nx+VEppRe+RATNCG4QaUhLFYFZoL+ZUkrEtTbbAlS/wc3/BcYFEkR6EA5/wlUgQB14h49UB1GoRQisJu55dFb5mY5017BLRal7OKrnMhgVjCA+DmlUMIOkhjW4XrkZRBFCiNw2v3L7CBJg0m5/fU7G1bTozcgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icocerrar.png
// module id = 2Jby
// module chunks = 1